import { Page, Navbar, Link, Block, Button } from "konsta/react";
import ReactSlider from "react-slider";
import { appSlice } from "../../app/appSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

function Brightness(props) {
  const dispatch = useAppDispatch();
  const editingLightBrightness = props.editingLightBrightness || "";
  const lightBrightness = useAppSelector(
    (state) => state.app[editingLightBrightness + "Brightness"]
  );
  return (
    <Page>
      <Navbar
        colors={{ bgIos: "bg-blue-trim", textIos: "text-white" }}
        translucent={false}
        title={editingLightBrightness
          .split(/(?=[A-Z])/)
          .map((key) => key.charAt(0).toUpperCase() + key.slice(1))
          .join(" ")}
        left={
          <Link
            colors={{ navbarTextIos: "text-white" }}
            navbar
            onClick={() =>
              dispatch(appSlice.actions.setEditingLightBrightness(""))
            }
          >
            Close
          </Link>
        }
      />
      <Block className="space-y-4 flex flex-col items-center">
        <h2 className="text-center text-2xl font-bold text-gray-600">
          {lightBrightness}% Brightness
        </h2>
        <Button
          large
          outline
          className="w-16 text-3xl"
          onClick={() => {
            if (lightBrightness < 100) {
              const newLightBrightness = Math.min(lightBrightness + 5, 100);
              dispatch(
                appSlice.actions[
                  "set" +
                    editingLightBrightness.charAt(0).toUpperCase() +
                    editingLightBrightness.slice(1) +
                    "Brightness"
                ](newLightBrightness)
              );
            }
          }}
        >
          +
        </Button>
        <div className="relative">
          <ReactSlider
            className="h-72 w-28 rounded-2xl bg-gray-400 overflow-hidden"
            onChange={(value) => {
              dispatch(
                appSlice.actions[
                  "set" +
                    editingLightBrightness.charAt(0).toUpperCase() +
                    editingLightBrightness.slice(1) +
                    "Brightness"
                ](value)
              );
            }}
            // trackClassName="bg-primary w-full"
            renderTrack={(props, state) => {
              if (state.index === 0) {
                props.className = "bg-primary w-full";
                return <div {...props} />;
              } else {
                props.className = "bg-gray-400 w-full";
                return <div {...props} />;
              }
            }}
            redner
            invert={true}
            defaultValue={0}
            value={lightBrightness}
            min={0}
            max={100}
            // marks
            // renderMark={(props) => {
            //   if (props.key < currentIndex) {
            //     props.className = "example-mark example-mark-completed";
            //   } else if (props.key === currentIndex) {
            //     props.className = "example-mark example-mark-active";
            //   }
            //   return <span {...props} />;
            // }}
            orientation="vertical"
          />
          <svg
            className="absolute pointer-events-none bottom-8 w-3/5 left-1/2 -translate-x-1/2"
            viewBox="0 0 50 84"
            style={{
              fillRule: "evenodd",
              clipRule: "evenodd",
              strokeLinejoin: "round",
              strokeMiterlimit: 2,
            }}
          >
            <g transform="matrix(1,0,0,1,-163,-332)">
              <g id="Icon-bulb">
                <path
                  id="Fill-1"
                  d="M177.363,391.714C177.386,388.9 177.419,384.917 175.565,382.429C174.78,381.375 173.941,380.304 173.082,379.208C168.335,373.151 163,366.343 163,357.51C163,343.422 174.192,332 188,332C201.807,332 213,343.422 213,357.51C213,365.316 208.355,371.385 204.117,376.924C202.678,378.804 201.286,380.623 200.138,382.429C198.374,385.202 198.506,388.993 198.599,391.684C198.667,393.628 198.714,394.998 198.013,394.998L177.923,394.998C177.336,394.998 177.348,393.626 177.363,391.714ZM181.323,406.83C180.407,406.83 179.665,407.585 179.665,408.53C179.665,409.469 180.423,410.231 181.323,410.231L194.672,410.231C195.588,410.231 196.332,409.476 196.332,408.53C196.332,407.592 195.572,406.83 194.672,406.83L181.323,406.83ZM178.007,401.728C177.08,401.728 176.33,402.483 176.33,403.429C176.33,404.367 177.078,405.129 178.007,405.129L197.985,405.129C198.912,405.129 199.663,404.374 199.663,403.429C199.663,402.49 198.913,401.728 197.985,401.728L178.007,401.728ZM178.007,396.626C177.08,396.626 176.33,397.381 176.33,398.326C176.33,399.265 177.078,400.027 178.007,400.027L197.985,400.027C198.912,400.027 199.663,399.272 199.663,398.326C199.663,397.388 198.913,396.626 197.985,396.626L178.007,396.626ZM184.665,410.231L184.665,412.782C184.665,414.192 185.795,415.333 187.165,415.333L188.83,415.333C190.212,415.333 191.332,414.2 191.332,412.782L191.332,410.231L184.665,410.231Z"
                  style={{ fill: "white" }}
                />
              </g>
            </g>
          </svg>
        </div>
        <Button
          large
          outline
          className="w-16 text-3xl"
          onClick={() => {
            if (lightBrightness > 0) {
              const newLightBrightness = Math.min(lightBrightness - 5, 100);
              dispatch(
                appSlice.actions[
                  "set" +
                    editingLightBrightness.charAt(0).toUpperCase() +
                    editingLightBrightness.slice(1) +
                    "Brightness"
                ](newLightBrightness)
              );
            }
          }}
        >
          -
        </Button>
      </Block>
    </Page>
  );
}

export default Brightness;
